import type { IconProps } from './types';

export const SearchSmallIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path
        d="M1.6875 11.0625C1.6875 13.5489 2.67522 15.9335 4.43337 17.6917C6.19153 19.4497 8.5761 20.4375 11.0625 20.4375C13.5489 20.4375 15.9335 19.4497 17.6917 17.6917C19.4497 15.9335 20.4375 13.5489 20.4375 11.0625C20.4375 8.5761 19.4497 6.19153 17.6917 4.43337C15.9335 2.67522 13.5489 1.6875 11.0625 1.6875C8.5761 1.6875 6.19153 2.67522 4.43337 4.43337C2.67522 6.19153 1.6875 8.5761 1.6875 11.0625Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="M17.625 17.625L22.3125 22.3125" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
